import { Component, OnInit, Input, Inject, Output, EventEmitter, Directive } from '@angular/core';
import { LoaderindicatorService } from '../../services/loaderindicator/loaderindicator.service';
import { DataCommunicationService } from '../../services/data_service/data-communication.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../../services/common_services/common.service';
import { TranslateService } from '@ngx-translate/core';
import { MgDecimalValuePipe } from './../../../Shared/pipe/decimalValue';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'mgfw-rental-car-list',
  templateUrl: './rental-car-list.component.html',
  styleUrls: ['./rental-car-list.component.css']
})
export class RentalCarListComponent implements OnInit {

  @Input() dateValue: any;
  @Input() showRentalCar: boolean;
  @Input() rentalCarPrice: any;
  @Input() rentalProvider: any;
  @Output() selectedRentalCarData = new EventEmitter<any>();

  searchParams: any;
  rentalCarList = [];
  localrentalCar;
  thirdpartyprice = null;
  dealerConfig;
  ThirdPartyRental: any;
  constructor(
    private loaderservice: LoaderindicatorService,
    private dataCommunicationService: DataCommunicationService,
    private commonService: CommonService,
    private translate: TranslateService,
  ) { }


  public getRentalCars(dateValue) {
    this.localrentalCar = this.commonService.getLocalStorage('RentalCar');
    // this.commonService.removeLocalStorage(['RentalCar']);
    // tslint:disable-next-line:max-line-length
    this.searchParams = { DealerNo: this.commonService.getLocalStorage('dealername'), status: true, AvailableDate: (dateValue.year + '-' + dateValue.month + '-' + dateValue.day) };
    this.translate.get('LoaderText.loading').subscribe(message => {
      this.loaderservice.show(message);
    });
    this.dataCommunicationService.getrentalCar(this.searchParams).subscribe(
      result => {
        this.loaderservice.hide();
        if (result.StatusCode === 1) {
          this.rentalCarList = result.Data;
        }
      }, error => {
        this.commonService.getErrorMessage('LoaderText.AlertMsg');
      });

  }
  public selectThirdPartyRentalCar(rentalCarData, $event) {
    if ($event.target.checked === false) {
      this.commonService.removeLocalStorage(['RentalCar']);
      rentalCarData == null;
      this.selectedRentalCarData.emit(this.thirdpartyprice);
    } else {
      if (rentalCarData != null) {
        if (this.dealerConfig.RentalCarPrice > 0 && this.showRentalCar) {
          this.translate.get('Common.CommonText.label.rentedcar').subscribe(message => {
            this.commonService.setLocalStorage('RentalCar', ({ "Brand": message, "RentalCarId": 0, "Price": this.dealerConfig.RentalCarPrice }));
            this.ThirdPartyRental = this.commonService.getLocalStorage('RentalCar');
            this.selectedRentalCarData.emit(this.commonService.getLocalStorage('RentalCar'));
          });
        }
      }
    }
  }
  public selectRentalCar(rentalCarData) {

    if (rentalCarData != null) {
      if (rentalCarData.RentalCarId === this.commonService.getLocalStorageByKey('RentalCar', 'RentalCarId')) {
        (document.getElementById(
          rentalCarData.LicensePlateNo + rentalCarData.Brand + rentalCarData.Model
        ) as HTMLInputElement).checked = false;
        this.commonService.removeLocalStorage(['RentalCar']);
        this.selectedRentalCarData.emit(rentalCarData);
      } else {
        (document.getElementById(
          rentalCarData.LicensePlateNo + rentalCarData.Brand + rentalCarData.Model
        ) as HTMLInputElement).checked = true;
        this.commonService.setLocalStorage('RentalCar', rentalCarData);
        this.selectedRentalCarData.emit(rentalCarData);
      }
    }
  }

  // public getCheckboxselected(serviceData) {
  //   // this.getServiceChecked();
  //    if (this.SelectedService.some(x => x.ServiceId === serviceData.ServiceId)) {
  //      return true;
  //    } else { return false; }
  //  }

  public checkSelectedRentalCar(car) {
    if (this.localrentalCar != null) {
      if (this.localrentalCar.RentalCarId == car.RentalCarId) {
        return true;
      }
    }
    return false;
  }

  ngOnInit() {
    this.commonService.removeLocalStorage(['RentalCar']);
    this.dealerConfig = this.commonService.getLocalStorage('dealerConfig');
    if (Number(this.rentalCarPrice) > 0) {

    } else {
      this.getRentalCars(this.dateValue);
    }
  }


}
